export type BetWonNotifyEvent = {
  id: string;
  type: 'bet_won';
  betId: string;
  horseName: string;
  course: string | null;
  profit: number;
  currency: string;
};

export type UserNotifyEvent = BetWonNotifyEvent;

export function isUserNotifyEvent(value: unknown): value is UserNotifyEvent {
  if (!value || typeof value !== 'object') return false;
  const o = value as Record<string, unknown>;
  return (
    typeof o.id === 'string' &&
    o.type === 'bet_won' &&
    typeof o.betId === 'string' &&
    typeof o.horseName === 'string' &&
    typeof o.profit === 'number' &&
    typeof o.currency === 'string'
  );
}
